import React from "react";
import { SidePanel, Form, FormBuilder } from "@redriver/cinnamon";
import { Grid } from "semantic-ui-react";
import Filter from "features/../../../shared/assets/white-filter.svg";
import { IconButton } from "features/../../../shared/components/buttons";
import { UserTypeCheck } from "features/../../../shared/components/auth";
import {
  PhysicalDocumentSheetStateIps,
  PhysicalDocumentSheetStatePrincipal,
  UserType,
} from "features/../../../shared/constants/enums";
import {
  CustomersTypeAheadLookup,
  DealerOfficesTypeAheadLookup,
  UserTypeAhead,
} from "features/../../../shared/features/Settings";
import { useTranslation } from "react-i18next";
import {
  DocuSignSheetStateDropdownLookup,
  PhysicalSheetStateDropdownLookup,
} from "features/Sheets";
import { ClientsDropdownLookup } from "features/Clients";
import { FieldNames } from "features/Agreements/AgreementFilter/AgreementSheetFilters";

const DocumentAuditTrailFilters = ({ value, onChange }) => {
  const { t } = useTranslation("documentAuditTrails", {
    keyPrefix: "FiltersSidePanel",
  });

  const { t: tPhysicalDocumentState } = useTranslation("enums", {
    keyPrefix: process.env.TRADE_AS_IPS
      ? "PhysicalDocumentSheetStateIps"
      : "PhysicalDocumentSheetStatePrincipal",
  });

  const { t: tState } = useTranslation("enums", {
    keyPrefix: process.env.TRADE_AS_IPS
      ? "SheetStateIps"
      : "SheetStatePrincipal",
  });

  return (
    <SidePanel
      closeIcon
      header={t("DocumentAuditTrailFilters")}
      trigger={<IconButton icon={Filter} primary content={t("Filters")} />}
    >
      <FormBuilder
        value={value}
        onChange={onChange}
        renderForm={(formProps) => (
          <div className="ui form highlighted-inputs">
            <Form {...formProps}>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <ClientsDropdownLookup
                      field="customerId"
                      label={t("FilterCustomer")}
                      fluid
                      clearable
                      placeholder={t("FilterSupplierOffice")}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <UserTypeCheck restrictTo={UserType.HQ}>
                      <DealerOfficesTypeAheadLookup
                        field="dealerOfficeId"
                        label={t("FilterSupplierOffice")}
                        fluid
                        clearable
                        placeholder={t("FilterSupplierOffice")}
                      />
                    </UserTypeCheck>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={2}>
                  <Grid.Column>
                    <DocuSignSheetStateDropdownLookup
                      field={
                        process.env.TRADE_AS_IPS
                          ? "sheetStatesIps"
                          : "sheetStatesPrincipal"
                      }
                      label={t("FilterSheetState")}
                      placeholder={t("FilterSheetState")}
                      clearable
                      fluid
                      multiple
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <UserTypeCheck restrictTo={UserType.HQ}>
                      <PhysicalSheetStateDropdownLookup
                        field={
                          process.env.TRADE_AS_IPS
                            ? "physicalDocumentSheetStateIps"
                            : "physicalDocumentSheetStatePrincipal"
                        }
                        label={t("FilterPhysicalSheetState")}
                        placeholder={t("FilterPhysicalSheetState")}
                        clearable
                        fluid
                        multiple
                      />
                    </UserTypeCheck>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={2}>
                  <Grid.Column>
                    <Form.Input
                      field="DocumentNumber"
                      label={t("DocumentNumber")}
                      fluid
                      clearable
                      placeholder={t("DocumentNumber")}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <UserTypeCheck restrictTo={UserType.HQ}>
                      <UserTypeAhead
                        field="sheetOwnerId"
                        label={t("FilterOwner")}
                        fluid
                        clearable
                        placeholder={t("FilterOwner")}
                      />
                    </UserTypeCheck>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={1}>
                  <Grid.Column>
                    <Form.DateRange
                      local
                      field="docusignDateRange"
                      label={t("SentToDocuSign")}
                      style={{ width: "100%" }}
                      fluid
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </div>
        )}
      />
    </SidePanel>
  );
};

export default DocumentAuditTrailFilters;
